import PropTypes from 'prop-types';

const PICKUP = 'pickup';
const DELIVERY_OFFER = 'deliveryOffer';
const ASSEMBLY = 'assembly';

const propType = PropTypes.oneOf([PICKUP, DELIVERY_OFFER, ASSEMBLY]);

export { PICKUP, DELIVERY_OFFER, ASSEMBLY, propType };
